<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="clickDetail">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            id="searchData"
            class="btn grey btn-import-form"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-popover
      ref="searchModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="searchData"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Data Siswa',
        // opt_title: 'Requester',
      },
      popoverSearchShow: false,
      filter_data: '',
      select_type: 'nama',
      options_search: [
        {
          text: 'NAMA',
          value: 'nama',
        },
      ],
      load_first: false,
      length_table: '',
      data_table: [],
      selected_rows: [],
      columns: ['id', 'nis', 'nama', 'created_date', 'updated_date'],
      options: {
        headings: {
          id: 'ID',
          nis: 'NIS',
          nama: 'NAMA',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['id', 'nisa', 'nama', 'created_date', 'updated_date'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : '',
              ascending: !!data.ascending,
              query: data.query ? data.query : '',
              query_type: data.query_type ? data.query_type : '',
            },
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListSiswa(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    selectTab(status) {
      this.tabSelected = status;
      this.refreshTable();
    },

    loading(val) {
      const a = val;
      a.pagination.query_type = this.select_type;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    clickDetail({ row }) {
      this.$router.replace(`/data-siswa/detail/${row.id}`);
    },

    createData() {
      this.$router.replace('/data-siswa/create');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/bimbingan-konseling/absen/jAbsenList.vue